// extracted by mini-css-extract-plugin
export default {"card":"FancyCard_card__1gD3A","cardBody":"FancyCard_cardBody__-Ev2g","title":"FancyCard_title__CzuXL","clickable":"FancyCard_clickable__+FORt"};